import table from '../../styles/shared/table.module.css';

export default function StatusDots({ items }) {
  return (
    <div className={table.statusDots}>
      {items.map(({ label, color }) => (
        <span
          key={label}
          className={table.statusDot}
          style={{ backgroundColor: color }}
          data-pr-tooltip={label}
        />
      ))}
    </div>
  );
}
